<template>
  <div class="chip" :style="{ background: color, color: textColor }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Chip',
  props: {
    color: { type: String, default: '#b5c3bc' },
    textColor: { type: String, default: '#11291b' },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  border-radius: 25px;
  font-size: 16px;
  font-weight: 700;
  margin-left: 5px;
  margin-right: 5px;
  padding: 4px 16px;
  text-align: center;
}
</style>
